import React from 'react'

import { Card, Col, Row } from 'antd'

import { formatMoney } from 'common/moneyFormatter'

import './styles.less'

export interface AllowanceTotalBoxProps {
  title: string
  amount: number
}

const AllowanceDataBox: React.FC<AllowanceTotalBoxProps> = (props) => {
  return (
    <Card className="allowance-box-card mb-8">
      <h6 className="color-gray-7">{props.title}</h6>
      <h3 className="semi-bold color-grey-9">{formatMoney(props.amount)} </h3>
    </Card>
  )
}

export default AllowanceDataBox
